import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars({ open, message, handleClose }) {
  React.useEffect(() => {
    setTimeout(handleClose, 5000);
  }, []);
  return (
    <Stack
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      spacing={2}
      sx={{ width: "100%" }}
    >
      <Snackbar open={open} autoHideDuration={6000}>
        <Alert severity="error">{message}</Alert>
      </Snackbar>
    </Stack>
  );
}
